<template>
<div class='b-form-notification'
     :class='{ "b-add-edit__form__option-disabled": disabled }'>
    <FeaturesSaveButton
        v-if='isSaveButtonShow'
        @click='setNotificationFeatureHandler'>
    </FeaturesSaveButton>

    <div class='h-text-center h-mv-20'>
        <div class='b-base-title h-mb-30'>
            {{ $t('Event.Reminders.Title') }}
        </div>
        <FormMenuItem
            v-for='(item, index) in notificationFeatureOptions'
            :key='index'
            :title='item.title'
            :isActive='index === activeIndex'
            leftIcon='time-icon'
            @click='activeIndex = index'>
        </FormMenuItem>
    </div>
</div>
</template>

<script lang='ts'>
import { Component, Emit, Prop, Vue } from 'vue-facing-decorator';
import { FormItemChoosedEventType } from '@/types/Events/Base';
import { FormMenuItem } from '@/components/simple/FormMenuItem';
import { notificationFeatureOptions } from '@/helpers/events';
import { FeaturesSaveButton } from '@/components/forms/features/FeaturesSaveButton';

@Component({
    components: {
        FormMenuItem,
        FeaturesSaveButton,
    },
})
export default class NotificationFeature extends Vue {
    @Prop({ type: Object, required: true }) readonly firstReminder!: FormItemChoosedEventType;
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

    activeIndex: number = 0;
    notificationFeatureOptions: Array<FormItemChoosedEventType> = notificationFeatureOptions;

    get isSaveButtonShow(): boolean {
        const index = this.notificationFeatureOptions.findIndex(item => item.title === this.firstReminder.title);
        return index !== this.activeIndex && !(!this.firstReminder && this.activeIndex === 0);
    }

    created() {
        const index = this.notificationFeatureOptions.findIndex(item => item.title === this.firstReminder.title);
        if (index !== -1) {
            this.activeIndex = index;
        }
    }

    @Emit('setNotificationFeature')
    setNotificationFeatureHandler() {
        return this.notificationFeatureOptions[this.activeIndex];
    }
}
</script>

<style lang='sass'>
.b-form-notification
    .icon-checked
        width: 100%
        border-radius: 10px
        background-color: #F7F8FA
        &__background
            background-color: #E8EBEF
            color: #fff
            border-radius: 50%
            height: 25px
            width: 25px
    .icon-checked__active
        .icon-checked__background
            background-color: $main-green
            color: #fff
</style>
